"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const PageSet = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M4.63 20.548c.28.28.609.421.983.421h14.043c1.071 0 1.405-.96 1.405-1.86H6.209V6.1l3 .003v-2H5.613c-.374 0-.702.14-.983.422-.28.28-.421.608-.421.983v14.056c0 .374.14.702.421.983Zm10.182-9.62a1.23 1.23 0 0 1-.9-.38 1.23 1.23 0 0 1-.379-.9c0-.363.126-.667.379-.912a1.25 1.25 0 0 1 .9-.367c.364 0 .668.122.913.367.244.245.367.55.367.912 0 .348-.123.648-.367.9-.245.253-.55.38-.913.38Zm4.217-.38c.253.253.553.38.9.38.364 0 .668-.127.913-.38a1.25 1.25 0 0 0 .367-.9c0-.363-.122-.667-.367-.912a1.239 1.239 0 0 0-.912-.367 1.25 1.25 0 0 0-.9.367c-.254.245-.38.55-.38.912 0 .348.127.648.38.9Zm-4.217-3.885a1.23 1.23 0 0 1-.9-.379 1.23 1.23 0 0 1-.379-.9c0-.364.126-.668.379-.912a1.25 1.25 0 0 1 .9-.368c.364 0 .668.123.913.368.244.244.367.548.367.912 0 .347-.123.647-.367.9-.245.253-.55.38-.913.38Zm4.217-.379c.253.253.553.38.9.38.364 0 .668-.127.913-.38a1.25 1.25 0 0 0 .367-.9c0-.364-.122-.668-.367-.912a1.239 1.239 0 0 0-.912-.368 1.25 1.25 0 0 0-.9.368c-.254.244-.38.548-.38.912 0 .347.127.647.38.9Zm.9 8.908a1.23 1.23 0 0 1-.9-.379 1.23 1.23 0 0 1-.379-.9c0-.363.127-.667.38-.912a1.25 1.25 0 0 1 .9-.367c.363 0 .667.122.912.367s.367.549.367.912c0 .348-.122.648-.367.9a1.22 1.22 0 0 1-.912.38Z",
        clipRule: "evenodd"
      }
    )
  );
};
export default PageSet;
